module.exports = __webpack_public_path__ + "media/images/subject_img/POLITICS-INTERNATIONAL RELATIONS-d8d2e0376c76e5a47772efbb6720f658.jpg";